import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Toolbox } from 'src/app/classes/toolbox';
import { ToolboxRead } from 'src/app/classes/toolbox-read';
import { CodaltComponent } from 'src/app/codalt.component';
import { ToolboxService } from 'src/app/services/toolbox.service';

@Component({
    selector: 'app-toolbox-read-dialog',
    templateUrl: './toolbox-read-dialog.component.html',
    styleUrls: ['./toolbox-read-dialog.component.scss'],
    standalone: false,
})
export class ToolboxReadDialogComponent extends CodaltComponent implements OnInit {
    readBy: ToolboxRead[];

    constructor(
        private toolboxService: ToolboxService,
        @Inject(MAT_DIALOG_DATA) public data: Toolbox,
        public dialogRef: MatDialogRef<ToolboxReadDialogComponent>
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.toolboxService.readBy(this.data.id).subscribe(read => {
                this.readBy = read.data.sort((a, b) =>
                    `${a.user.lastname} ${a.user.firstname}`.localeCompare(`${b.user.lastname}${b.user.firstname}`)
                );
            })
        );
    }

    close() {
        this.dialogRef.close();
    }
}
